<template>
   <div>
        <div class="card-body">
            <form @submit="submitHandle($event)" action="" class="info-submit m-auto text-center">
                <div class="panel-tutorial">
                    <p class="title-line1">hướng dẫn làm bài</p>
                    <ul>
                        <li><span>01.</span>Bài kiểm tra bao gồm 02 phần: Listening, Reading & Writing.</li>
                        <li><span>02.</span>Bài kiểm tra diễn ra trong thời gian 25 phút.</li>
                        <li><span>03.</span>Bài kiểm tra sẽ tự động kết thúc và ghi nhận kết quả khi hết thời gian làm bài.</li>
                        <li><span>04.</span>Bạn nhỏ làm bài ở nơi yên tĩnh, có kết nối mạng ổn định.</li>
                        <li><span>05.</span>Bạn nhỏ đừng quên chuyển ngôn ngữ ở máy sang tiếng Anh trước khi làm bài nhé!</li>
                    </ul>
                    <h3 class="mt-5">CHÚC BẠN NHỎ HOÀN THÀNH THẬT TỐT BÀI THI!</h3>    
                </div>
                <button class="mt-3 m-auto border-0 bg-transparent">
                    <img class="mw-100" src="../../assets/newyear/btn-batdaulambai.png" alt="">
                </button>
            </form>
        </div>
   </div>
</template>

<script>
export default {
    mounted () {
    },
    methods: {
        submitHandle(event) {
            event.preventDefault();
            this.$store.commit('SET_PAGE', 3)
        }
    }
}
</script>

<style scoped>

ul {
    list-style: decimal-leading-zero;
    text-align: left
}

ul li {
    margin-bottom: 15px;
    font-family: 'Roboto-Medium';
    font-size: 1.3rem;
}

ul li::marker {
    color: #0d5fcb;
    font-family: 'Nunito', sans-serif;;
}

.title-line1 {
    text-transform: uppercase;
    font-family: 'Nunito', sans-serif;;
    font-size: 2rem;
    font-weight: 600;
    color: #fc7b32;
}

.panel-tutorial h3 {
    color: #0099ff;
    font-size: 1.3rem;
    font-weight: 600;
    font-family: 'Nunito', sans-serif;;
}

.panel-tutorial {
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 50px;
    border-radius: 35px;
    border: 3px solid #0099ff;
    background-color: #fff;
    box-shadow: 0px 12px 18px -8px #000000a1
}
</style>

<style>
@media (max-width: 768px) {
    
}
</style>